export const NLI = {
	Title: "title",
	Source: "source",
	"The Creator": "_authors",
	"Creation Date": "year",
	Subject: "desc",
	"Doc Id": "external_id",
};


export const Scholten = {
	Title: "label"
};
